export enum InputFieldType {
  Default = 0,
  Text = 1,
  Email = 2,
  Number = 3,
  BusinessID = 4
}
